//设计资源详情
import { getDesignResAPI } from "@/apis/design";
import { Flex, Card, Image, Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { downloadFileWithSaveDialog } from "@/apis/file";
import { SERVER_CONF } from '@/config/server'
const BASE_SERVER_URL_LOCAL = SERVER_CONF.BASE_URL

const DesignResDetail = () => {

    const { t } = useTranslation();

    const [searchParams] = useSearchParams();
    const [designRes, setDesignRes] = useState([])
    const [fileId, setFileId] = useState(0)
    const [photo, setPhoto] = useState()
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const designResId = searchParams.get("id")

    const navigate = useNavigate()


    const showModal1 = () => {
        //console.log("showLocation:", showLocation);
        setIsModalOpen1(true);
    };
    const handleOk1 = () => {
        showPointCloud()
        setIsModalOpen1(false);
    };
    const handleCancel1 = () => {
        setIsModalOpen1(false);
    };

    const showPointCloud = () => {
        navigate(`/PointCloud?id=${designResId}`)
    }

    // 下载单个文件，浏览器会弹出保存对话框
    const handleDownload = async () => {
        try {
            await downloadFileWithSaveDialog(fileId);
        } catch (error) {
            console.error('下载失败:', error);
        }
    };

    useEffect(() => {
        //通过接口获取设计资源信息
        async function getDesignResByAPI() {
            if (designResId != null) {
                try {
                    let res = await getDesignResAPI(designResId)
                    setDesignRes(res.data)
                    setFileId(res.data.designFile)
                    const currPhoto = res.data.photo
                    setPhoto(currPhoto)
                } catch (error) {
                    console.error("Error fetching design resource:", error);
                }
            }
        }
        getDesignResByAPI()
    }, [designResId])

    return (
        <Flex justify={"center"}>
            <Card
                size="small"
                title={designRes.placeName}
                hoverable
                cover={<Image className='card-img' src={BASE_SERVER_URL_LOCAL + photo} alt='' />}
                className='card'
                style={{
                    width: 300,
                }} />
            <Flex vertical style={{ width: 500, marginTop: 50, marginLeft: 50 }}>
                <p>projectName:{designRes.projectName}</p>
                <p>positionName:{designRes.positionName}</p>
                <p>otherInfo:{designRes.otherInfo}</p>
                {/* <Button onClick={showModal} style={{ width: 200 }} type="primary">
          设计资源分享
        </Button> */}
                <Button onClick={handleDownload} style={{ width: 200 }} type="primary">
                    设计资源下载
                </Button>
                <Button onClick={showModal1} style={{ width: 200, marginTop: 20 }} disabled>
                    设计资源展示
                </Button>
            </Flex>
            {/* <Modal title={"设计资源分享"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <p>...........</p>
        <Button icon={<WechatFilled />} />
      </Modal> */}
            <Modal title={"设计资源展示"} open={isModalOpen1} onOk={handleOk1} onCancel={handleCancel1}>
                <p>{t('Message.Warning.GraphicsCardResourceRequirements')}</p>
            </Modal>
        </Flex>
    )
}
export default DesignResDetail